import { createSlice } from "@reduxjs/toolkit";

const initialState = { data: [], error: false, isLoading: true };

export const getCommByFIdSlice = createSlice({
    name: 'getCommByFId',
    initialState,
    reducers: {
        getCommByFIdSuccess: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        },
        getCommByFIdFailure: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
            state.error = true;
        }
    }

})

export const {getCommByFIdSuccess, getCommByFIdFailure } = getCommByFIdSlice.actions;

export default getCommByFIdSlice.reducer